import React, { useState } from "react";
// import { shallowEqual, useSelector } from "react-redux";
import { PayRegistrationStep1 } from "./step1";
import CmsRegistrationForm from "./CmsRegistrationForm";
// import { PayRegistrationStep2 } from "./step2";
export const PayRegistration = () => {
  const [isCmsRegistrationForm, setIsCmsRegistrationForm] = useState(false);

  // const {
  //   isCmsRegistrationModal,
  //   company,
  //   // employee
  // } = useSelector(
  //   (store) => ({
  //     // employee: store.Profile.employee,
  //     isCmsRegistrationModal: store.Data.isCmsRegistrationModal,
  //     company: store.Profile.company,
  //   }),
  //   shallowEqual
  // );


  return (
    <div className="pay-portal">
      <div className="pay-container">
        <div className="pay-contents">
          <PayRegistrationStep1 setIsCmsRegistrationForm={setIsCmsRegistrationForm} />
          {/* <PayRegistrationStep2 /> */}
        </div>
      </div>

      <CmsRegistrationForm open={isCmsRegistrationForm} setOpen={setIsCmsRegistrationForm} />
    </div>
  );
};
